import { defineComponent, computed } from 'vue';
import __vue_component__ from './subComponents/TabButton.vue.js';
import __vue_component__$1 from '../../transitions/TransitionResize.vue.js';

var script = defineComponent({
    name: 'Tabs',
    components: {
        TabButton: __vue_component__,
        TransitionResize: __vue_component__$1,
    },
    model: {
        prop: 'activeTabID',
        event: 'updateActiveTabID',
    },
    props: {
        activeTabID: {
            type: String,
            default: null,
        },
        tabs: {
            type: Array,
            required: true,
        },
        transition: Boolean,
    },
    setup(props, { emit }) {
        var _a;
        // Select first tab if no activeTabID passed.
        if (!props.activeTabID) {
            const firstTabID = (_a = props.tabs[0]) === null || _a === void 0 ? void 0 : _a.id;
            emit('updateActiveTabID', firstTabID);
        }
        const activeTabComponent = computed(() => {
            const activeTab = props.tabs.find((tab) => tab.id === props.activeTabID);
            return activeTab === null || activeTab === void 0 ? void 0 : activeTab.component;
        });
        const contentWrapper = computed(() => props.transition ? __vue_component__$1 : 'div');
        return {
            activeTabComponent,
            contentWrapper,
        };
    },
});

export { script as default };
